import { Route } from "react-router-dom";
import ParentProtectedRoute from "components/ParentProtectedRoute";
import Wisdom from "../pages/Wisdom";

export const StaffRoutes = () => [
    <Route key="parent login page" path="/staff/login" element={ <Wisdom /> } />,
    <Route key="wisdom main page" path="/staff" element={
        <ParentProtectedRoute>
            <Wisdom />
        </ParentProtectedRoute>
    } />,
];